import React, { useRef, useState, useEffect } from "react";
import indiaEmblem from "../assets/india.png";
import jharkhandLogo from "../assets/Jharkhand_logo.jpg";
import panchayatiRajLogo from "../assets/panchayti_raj.jpg";
import userPlaceholder from "../assets/user.png";
import banner1 from "../assets/jh-banner_poster.png";
import backgroundImage from "../assets/jharkhand-map-slide1.png";
import banner2 from "../assets/crousal_img-2.jpg";
import banner3 from "../assets/crousal_image-3.jpg";
import banner4 from "../assets/crousal_image-4.jpg";
import banner5 from "../assets/crousal_image-5.jpg";
import image1 from "../assets/jharkhand_CM.jpg";
import image2 from "../assets/Hon._Dipika_Pandey_Singh.jpeg";
import image3 from "../assets/IAS Manoj Kumar.jpg";
import image4 from "../assets/ias-officer-rajeshwari.jpg";

import { FaTrophy, FaFacebook, FaYoutube, FaArrowRight } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdOutlineSecurity, MdOutlineAnalytics, MdOutlineSettings, MdCheckCircle } from "react-icons/md";
import { FiEye } from "react-icons/fi";

export default function LandingPage() {
  const carouselRef = useRef(null);
  const heroBanners = [banner1, banner2, banner3, banner4, banner5];

  // Cloned array for seamless loop: [Banner 5, Banner 1, Banner 2, Banner 3, Banner 4, Banner 5, Banner 1]
  const extendedHeroBanners = [
    heroBanners[heroBanners.length - 1],
    ...heroBanners,
    heroBanners[0]
  ];

  const [heroIndex, setHeroIndex] = useState(1);
  const [isAnimating, setIsAnimating] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  // Auto-play timer for hero carousel (slides every 4.5 seconds)
  useEffect(() => {
    if (isPaused) return;

    const timer = setInterval(() => {
      setIsAnimating(true);
      setHeroIndex((prev) => prev + 1);
    }, 4500);

    return () => clearInterval(timer);
  }, [isPaused, heroIndex]);

  const scroll = (direction) => {
    if (carouselRef.current) {
      const { clientWidth } = carouselRef.current;
      const scrollAmount = direction === "left" ? -clientWidth / 2 : clientWidth / 2;
      carouselRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const scrollHero = (direction) => {
    if (direction === "right") {
      setIsAnimating(true);
      setHeroIndex((prev) => prev + 1);
    } else {
      setIsAnimating(true);
      setHeroIndex((prev) => prev - 1);
    }
  };

  const scrollToHeroSlide = (realIndex) => {
    setIsAnimating(true);
    setHeroIndex(realIndex + 1);
  };

  const handleTransitionEnd = () => {
    if (heroIndex === extendedHeroBanners.length - 1) {
      // Reached the right clone -> snap silently to real Banner 1
      setIsAnimating(false);
      setHeroIndex(1);
    } else if (heroIndex === 0) {
      // Reached the left clone -> snap silently to real Banner 5
      setIsAnimating(false);
      setHeroIndex(heroBanners.length);
    }
  };

  const activeHeroDotIndex = (heroIndex - 1 + heroBanners.length) % heroBanners.length;

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800">

      {/* Hero Image Carousel */}
      <section
        className="w-full relative group overflow-hidden"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Animated Auto-Play Progress Bar */}
        <div className="absolute top-0 left-0 w-full h-1 bg-white/20 z-40 overflow-hidden pointer-events-none">
          <div
            key={`${heroIndex}-${isPaused}`}
            className="h-full bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-300"
            style={{
              width: isPaused ? '0%' : '100%',
              transition: isPaused ? 'none' : 'width 4500ms linear'
            }}
          />
        </div>

        {/* Left Arrow Button */}
        <button
          onClick={() => scrollHero('left')}
          aria-label="Previous Slide"
          style={{ padding: 0, width: '48px', height: '48px', minWidth: '48px', minHeight: '48px', borderRadius: '50%' }}
          className="flex absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-30 bg-white hover:bg-emerald-600 shadow-2xl items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 border border-slate-300 cursor-pointer group/btn opacity-80 hover:opacity-100"
        >
          <svg
            className="w-6 h-6 text-slate-900 group-hover/btn:text-white transition-colors duration-200"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>

        {/* Right Arrow Button */}
        <button
          onClick={() => scrollHero('right')}
          aria-label="Next Slide"
          style={{ padding: 0, width: '48px', height: '48px', minWidth: '48px', minHeight: '48px', borderRadius: '50%' }}
          className="flex absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-30 bg-white hover:bg-emerald-600 shadow-2xl items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 border border-slate-300 cursor-pointer group/btn opacity-80 hover:opacity-100"
        >
          <svg
            className="w-6 h-6 text-slate-900 group-hover/btn:text-white transition-colors duration-200"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>

        {/* Hero Banner Slider Container */}
        <div className="w-full overflow-hidden">
          <div
            onTransitionEnd={handleTransitionEnd}
            style={{
              transform: `translateX(-${heroIndex * 100}%)`,
              transition: isAnimating ? 'transform 600ms cubic-bezier(0.25, 1, 0.5, 1)' : 'none'
            }}
            className="flex w-full"
          >
            {extendedHeroBanners.map((imgSrc, idx) => {
              const isActive = idx === heroIndex;
              return (
                <div key={idx} className="flex-none w-full relative h-[250px] sm:h-[350px] md:h-[450px] lg:h-[550px] overflow-hidden">
                  <img
                    src={imgSrc}
                    alt={`Hero Banner ${idx}`}
                    className={`w-full h-full object-cover object-center transition-all duration-700 ease-out ${isActive ? 'scale-105 opacity-100' : 'scale-100 opacity-80'
                      }`}
                  />
                </div>
              );
            })}
          </div>
        </div>

        {/* Carousel Slide Indicators / Dots */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 bg-slate-900/70 backdrop-blur-md px-4 py-2 rounded-full border border-white/20 shadow-xl">
          {heroBanners.map((_, idx) => (
            <button
              key={idx}
              onClick={() => scrollToHeroSlide(idx)}
              style={{ padding: 0, minWidth: 'unset' }}
              className={`h-2.5 rounded-full transition-all duration-300 cursor-pointer ${activeHeroDotIndex === idx ? 'w-8 bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.8)]' : 'w-2.5 bg-white/60 hover:bg-white'}`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Hero Banner Footer Divider Line */}
      <div className="w-full h-1.5 bg-gradient-to-r from-amber-400 via-emerald-500 to-blue-600 shadow-md relative z-20"></div>

      {/* Modern Banners Section - Parallax Background */}
      <section
        className="w-full relative overflow-hidden border-b border-slate-200 bg-fixed bg-center bg-cover"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* Green tint overlay for parallax background */}
        <div className="absolute inset-0 bg-emerald-900/80 pointer-events-none"></div>

        <div className="max-w-[1400px] mx-auto px-4 py-16 relative group z-10">

          {/* Line Badge Design */}
          <div className="flex items-center justify-center gap-4 mb-6 max-w-xl mx-auto">
            <div className="h-0.5 bg-gradient-to-r from-transparent via-amber-400 to-amber-400 flex-1 rounded-full"></div>
            <span className="inline-block px-5 py-1.5 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-400/40 text-xs font-bold uppercase tracking-widest backdrop-blur-md shadow-sm">
              उत्कृष्ट पंचायत एवं प्रोत्साहन पुरस्कार
            </span>
            <div className="h-0.5 bg-gradient-to-l from-transparent via-amber-400 to-amber-400 flex-1 rounded-full"></div>
          </div>

          {/* Left Banner Arrow Button */}
          <button
            onClick={() => scroll('left')}
            aria-label="Previous Banner"
            style={{ padding: 0, width: '48px', height: '48px', minWidth: '48px', minHeight: '48px', borderRadius: '50%' }}
            className="flex absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-30 bg-white hover:bg-emerald-600 shadow-2xl items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 border border-slate-300 cursor-pointer group/btn"
          >
            <svg
              className="w-6 h-6 text-slate-900 group-hover/btn:text-white transition-colors duration-200"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </button>

          {/* Right Banner Arrow Button */}
          <button
            onClick={() => scroll('right')}
            aria-label="Next Banner"
            style={{ padding: 0, width: '48px', height: '48px', minWidth: '48px', minHeight: '48px', borderRadius: '50%' }}
            className="flex absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-30 bg-white hover:bg-emerald-600 shadow-2xl items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 border border-slate-300 cursor-pointer group/btn"
          >
            <svg
              className="w-6 h-6 text-slate-900 group-hover/btn:text-white transition-colors duration-200"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </button>

          <div
            ref={carouselRef}
            className="flex gap-8 overflow-x-auto snap-x snap-mandatory pb-6 pt-2 px-2 scroll-smooth [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
          >

            {/* Banner 1: Modern Blue Gradient */}
            <div className="flex-none w-[85vw] md:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)] snap-start relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 bg-gradient-to-br from-[#1e4b8f] via-[#2a64ba] to-[#0f2d59] p-1 flex flex-col h-[380px]">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-400 opacity-10 rounded-full blur-2xl translate-y-1/3 -translate-x-1/4"></div>

              <div className="flex justify-between px-4 pt-4 mb-4 relative z-10">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center text-sm font-bold shadow-sm">20</div>
                <div className="flex gap-2">
                  <img src={jharkhandLogo} className="h-10 rounded-full shadow-sm" alt="logo" />
                  <img src={panchayatiRajLogo} className="h-10 rounded-full shadow-sm" alt="logo" />
                </div>
              </div>

              <div className="text-white text-center py-2 px-6 relative z-10 flex-1 flex flex-col justify-center">
                <h3 className="text-lg font-medium tracking-wide text-blue-100 uppercase">मुख्यमंत्री पंचायत</h3>
                <h3 className="text-lg font-medium tracking-wide mb-1 text-blue-100 uppercase">प्रोत्साहन योजना</h3>
                <h2 className="text-[#facc15] text-4xl font-black mt-2 drop-shadow-md tracking-tight">उत्कृष्ट पंचायत</h2>
                <div className="absolute -left-4 top-1/2 -translate-y-1/2 text-white/10">
                  <FaTrophy size={120} />
                </div>
              </div>

              <div className="flex justify-between gap-3 px-3 pb-3 relative z-10 mt-auto">
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-2xl flex-1 text-center p-3 relative shadow-inner">
                  <div className="absolute -top-3 -left-2 w-7 h-7 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold rounded-full flex items-center justify-center shadow-md">A</div>
                  <div className="text-xs font-medium text-blue-100 mb-2">ग्राम पंचायत<br />24 संख्या</div>
                  <div className="bg-white rounded-xl text-black py-2 px-1 shadow-sm flex flex-col items-center justify-center">
                    <span className="text-blue-600 font-black text-xl leading-none">₹10L</span>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-2xl flex-1 text-center p-3 relative shadow-inner">
                  <div className="absolute -top-3 -left-2 w-7 h-7 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold rounded-full flex items-center justify-center shadow-md">B</div>
                  <div className="text-xs font-medium text-blue-100 mb-2">पंचायत समिति<br />05 संख्या</div>
                  <div className="bg-white rounded-xl text-black py-2 px-1 shadow-sm flex flex-col items-center justify-center">
                    <span className="text-blue-600 font-black text-xl leading-none">₹15L</span>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-2xl flex-1 text-center p-3 relative shadow-inner">
                  <div className="absolute -top-3 -left-2 w-7 h-7 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold rounded-full flex items-center justify-center shadow-md">C</div>
                  <div className="text-xs font-medium text-blue-100 mb-2">जिला परिषद्<br />02 संख्या</div>
                  <div className="bg-white rounded-xl text-black py-2 px-1 shadow-sm flex flex-col items-center justify-center">
                    <span className="text-blue-600 font-black text-xl leading-none">₹20L</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Banner 2: Modern Red/Yellow Gradient */}
            <div className="flex-none w-[85vw] md:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)] snap-start relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 bg-gradient-to-br from-[#da2c38] via-[#e84a5f] to-[#b31b27] p-1 flex flex-col h-[380px]">
              <div className="absolute bottom-0 right-0 w-80 h-80 bg-yellow-400 opacity-20 rounded-full blur-3xl translate-y-1/3 translate-x-1/3"></div>

              <div className="flex justify-between px-4 pt-4 mb-4 relative z-10">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center text-sm font-bold shadow-sm">20</div>
                <div className="flex gap-2">
                  <img src={jharkhandLogo} className="h-10 rounded-full shadow-sm" alt="logo" />
                  <img src={panchayatiRajLogo} className="h-10 rounded-full shadow-sm" alt="logo" />
                </div>
              </div>

              <div className="flex mt-2 px-4 relative z-10 flex-1">
                <div className="text-white flex flex-col justify-center w-3/5">
                  <h3 className="text-sm font-medium tracking-wider text-red-100 uppercase">मुख्यमंत्री पंचायत प्रोत्साहन</h3>
                  <h2 className="text-[#facc15] text-4xl font-black mt-1 drop-shadow-md">ग्राम सभा</h2>
                </div>
                <div className="w-2/5 flex flex-col justify-center items-end relative">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white/20">
                    <FaTrophy size={100} />
                  </div>
                  <div className="text-white font-black text-5xl relative z-10 flex items-start drop-shadow-lg">
                    <span className="text-2xl mt-2 text-yellow-300">₹</span>4<span className="text-xl mt-auto mb-1 ml-1 text-yellow-300">L</span>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-xl border border-white/20 text-white mt-4 p-4 text-center rounded-2xl mx-3 mb-3 shadow-inner relative z-10">
                <div className="flex justify-between items-center gap-4">
                  <span className="text-xs font-medium text-red-50 text-left leading-relaxed">अनुसूचित क्षेत्र एवं गैर-अनुसूचित<br />क्षेत्र में ग्राम सभा को पुरस्कार</span>
                  <div className="flex flex-col items-center justify-center bg-white/20 rounded-xl px-4 py-2">
                    <span className="text-3xl font-black text-white drop-shadow-md leading-none">48</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Banner 3: Modern Emerald Gradient */}
            <div className="flex-none w-[85vw] md:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)] snap-start relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 bg-gradient-to-br from-[#10b981] via-[#059669] to-[#047857] p-1 flex flex-col h-[380px]">
              <div className="absolute top-0 left-0 w-64 h-64 bg-emerald-300 opacity-20 rounded-full blur-3xl -translate-y-1/3 -translate-x-1/3"></div>

              <div className="flex justify-between px-4 pt-4 mb-4 relative z-10">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center text-sm font-bold shadow-sm">20</div>
                <div className="flex gap-2">
                  <img src={jharkhandLogo} className="h-10 rounded-full shadow-sm" alt="logo" />
                  <img src={panchayatiRajLogo} className="h-10 rounded-full shadow-sm" alt="logo" />
                </div>
              </div>

              <div className="text-white text-center py-2 px-6 relative z-10 flex-1 flex flex-col justify-center">
                <h3 className="text-sm font-medium tracking-widest text-emerald-100 uppercase mb-2">मुख्यमंत्री पंचायत प्रोत्साहन</h3>
                <h2 className="text-[#facc15] text-4xl font-black drop-shadow-md tracking-tight">स्वच्छ एवं स्वस्थ</h2>
                <div className="absolute -right-4 top-1/2 -translate-y-1/2 text-white/10">
                  <FaTrophy size={120} />
                </div>
              </div>

              <div className="flex justify-between gap-3 px-3 pb-3 relative z-10 mt-auto">
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-2xl flex-1 text-center p-3 relative shadow-inner">
                  <div className="absolute -top-3 -left-2 w-7 h-7 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold rounded-full flex items-center justify-center shadow-md">A</div>
                  <div className="text-xs font-medium text-emerald-100 mb-2">ग्राम पंचायत<br />24 संख्या</div>
                  <div className="bg-white rounded-xl text-black py-2 px-1 shadow-sm flex flex-col items-center justify-center">
                    <span className="text-emerald-600 font-black text-xl leading-none">₹10L</span>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-2xl flex-1 text-center p-3 relative shadow-inner">
                  <div className="absolute -top-3 -left-2 w-7 h-7 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold rounded-full flex items-center justify-center shadow-md">B</div>
                  <div className="text-xs font-medium text-emerald-100 mb-2">पंचायत समिति<br />05 संख्या</div>
                  <div className="bg-white rounded-xl text-black py-2 px-1 shadow-sm flex flex-col items-center justify-center">
                    <span className="text-emerald-600 font-black text-xl leading-none">₹15L</span>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-lg border border-white/20 text-white rounded-2xl flex-1 text-center p-3 relative shadow-inner">
                  <div className="absolute -top-3 -left-2 w-7 h-7 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold rounded-full flex items-center justify-center shadow-md">C</div>
                  <div className="text-xs font-medium text-emerald-100 mb-2">जिला परिषद्<br />02 संख्या</div>
                  <div className="bg-white rounded-xl text-black py-2 px-1 shadow-sm flex flex-col items-center justify-center">
                    <span className="text-emerald-600 font-black text-xl leading-none">₹20L</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section >

      {/* Modern Marquee Notice Bar */}
      < section className="w-full bg-gradient-to-r from-blue-900 to-indigo-900 shadow-md" >
        <div className="flex h-12 items-center max-w-[1400px] mx-auto overflow-hidden">
          <div className="bg-gradient-to-r from-red-600 to-red-500 text-white h-full px-8 flex items-center font-bold text-sm tracking-wider whitespace-nowrap z-10 shadow-lg relative">
            IMPORTANT NOTICES
            <div className="absolute -right-4 top-0 w-8 h-full bg-gradient-to-r from-red-500 to-transparent skew-x-12"></div>
          </div>
          <div className="flex-1 relative flex items-center pl-8 text-white">
            <div className="w-2.5 h-2.5 bg-green-400 rounded-full mr-4 flex-shrink-0 animate-pulse shadow-[0_0_10px_rgba(74,222,128,0.8)]"></div>
            <div className="whitespace-nowrap animate-[marquee_20s_linear_infinite] flex items-center text-sm font-medium tracking-wide">
              Notice for Document Verification for various posts under Department of Panchayati Raj • New Guidelines for Gram Sabha 2024-25 Released
            </div>
          </div>
        </div>
      </section >

      {/* About Section - Modern Typography and Shadows */}
      < section className="w-full relative bg-white border-y border-slate-100 overflow-hidden" >

        {/* Massive Faint Logo in Background */}
        < div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/3 opacity-[0.04] pointer-events-none" >
          <img src={jharkhandLogo} alt="background pattern" className="w-[800px] h-[800px] object-cover rounded-full grayscale" />
        </div >

        {/* Soft colorful glows */}
        < div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-400 rounded-full mix-blend-multiply filter blur-[128px] opacity-10 animate-pulse" ></div >
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-emerald-400 rounded-full mix-blend-multiply filter blur-[128px] opacity-10 animate-pulse"></div>

        <div className="max-w-[1400px] mx-auto px-4 py-24 flex flex-col lg:flex-row gap-16 relative z-10">
          <div className="lg:w-1/2">
            <div className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 font-bold text-xs tracking-widest uppercase mb-4">Department Overview</div>
            <h2 className="text-4xl font-black mb-6 text-slate-900 tracking-tight">About DOPR</h2>
            <div className="text-slate-600 text-base leading-relaxed space-y-6 mb-10">
              <p>
                In order to strengthen Panchayati Raj Institutions as per the spirit of the Constitution and the Jharkhand Panchayat Raj Act, 2001, the Department of Panchayati Raj has undertaken several schemes such as the construction of Panchayat Bhawans, grants to Zilla Parishad areas, construction of Dak Bungalows, office buildings, bus stands, training for PRI officials, and grants to Gram Sabhas.
              </p>
              <p>
                In a federation, the powers and functions of the government are divided between two levels of government. With the passage of the 73rd and 74th Amendment Acts of the Constitution of India in 1993, the division of powers and functions has been further extended to Local Self-Governments.
              </p>
            </div>

            {/* Modern Mission and Vision Cards */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 flex items-start gap-6 shadow-xl shadow-blue-900/5 hover:shadow-2xl hover:-translate-y-1 transition-all border border-slate-100">
                <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center flex-shrink-0 text-white shadow-lg shadow-blue-500/30">
                  <MdOutlineAnalytics size={28} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">Our Mission</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    Empower Panchayats and representatives of PRIs to plan holistic development by making them realize their rights, entitlements, and duties through effective delivery of services.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 flex items-start gap-6 shadow-xl shadow-emerald-900/5 hover:shadow-2xl hover:-translate-y-1 transition-all border border-slate-100">
                <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center flex-shrink-0 text-white shadow-lg shadow-emerald-500/30">
                  <FiEye size={28} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">Our Vision</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    To accomplish decentralized and good local self-governance through empowered and efficient Panchayati Raj Institutions.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Modern Officials Grid */}
          <div className="lg:w-1/2 grid grid-cols-2 gap-6">
            {[
              { name: "Shri Hemant Soren", title: "Hon'ble Chief Minister", dept: "Jharkhand Government", img: image1 },
              { name: "Smt. Deepika Pandey Singh", title: "Hon'ble Minister", dept: "Panchayati Raj Dept", img: image2 },
              { name: "Shri Manoj Kumar, IAS", title: "Secretary", dept: "Department of Panchayati Raj", img: image3 },
              { name: "Smt Rajeshwari B., IAS", title: "Director", dept: "Department of Panchayati Raj", img: image4 }
            ].map((official, idx) => (
              <div key={idx} className="group relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-80 z-10 transition-opacity group-hover:opacity-90"></div>
                <img src={official?.img} alt={official?.name} className="w-full h-[280px] object-cover object-top transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute bottom-0 left-0 w-full p-5 z-20 transform translate-y-2 group-hover:translate-y-0 transition-transform">
                  <p className="font-bold text-lg text-white drop-shadow-md">{official?.name}</p>
                  <p className="text-sm text-slate-300 font-medium mt-1 drop-shadow-sm">{official?.title}</p>
                  <p className="text-xs text-slate-400 font-medium">{official?.dept}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modern Floating Action Button (Popup Style) */}
        <div className="fixed bottom-8 right-8 z-50 group">
          {/* Subtle glowing pulse effect behind the button */}
          <div className="absolute inset-0 bg-emerald-500 rounded-full blur-lg opacity-40 group-hover:opacity-70 transition-opacity duration-300 animate-pulse"></div>

          <div className="relative bg-gradient-to-r from-emerald-500 to-green-600 text-white px-6 py-3.5 rounded-full font-bold tracking-wide text-sm flex items-center gap-3 cursor-pointer hover:-translate-y-1.5 hover:shadow-[0_15px_40px_rgb(16,185,129,0.4)] transition-all duration-300 border border-white/20 backdrop-blur-md">
            <div className="bg-white/20 p-1 rounded-full backdrop-blur-md flex items-center justify-center">
              <img src={jharkhandLogo} className="w-7 h-7 rounded-full bg-white shadow-sm p-0.5" alt="logo" />
            </div>
            <span>Jharkhand Sarkar</span>
          </div>
        </div>
      </section >

      {/* Modern Schemes Section - Mesh Gradient */}
      < section className="w-full bg-slate-900 py-24 text-white relative overflow-hidden" >
        {/* Abstract Mesh Background Elements */}
        < div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-600 rounded-full mix-blend-multiply filter blur-[128px] opacity-40 animate-blob" ></div >
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-600 rounded-full mix-blend-multiply filter blur-[128px] opacity-40 animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 w-[500px] h-[500px] bg-emerald-600 rounded-full mix-blend-multiply filter blur-[128px] opacity-30 animate-blob animation-delay-4000"></div>

        <div className="max-w-[1400px] mx-auto px-4 relative z-10">
          <div className="flex justify-between items-end mb-12">
            <div>
              <div className="inline-block px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-emerald-300 font-bold text-xs tracking-widest uppercase mb-3">Programs</div>
              <h2 className="text-4xl font-black">Schemes & Initiatives</h2>
            </div>
            <button className="hidden md:flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full transition-colors border border-white/10 font-semibold text-sm">
              View All <FaArrowRight />
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { title: "Vibrant Gram Sabha", desc: "Performance parameters of the key focus areas at the GP/ Village levels are tracked.", icon: <MdOutlineSecurity size={28} /> },
              { title: "eGramSwaraj", desc: "Aims to bring transparency in decentralised planning, progress reporting and accounting.", icon: <MdOutlineSettings size={28} /> },
              { title: "AuditOnline", desc: "Facilitates internal & external audit of Government department/ Panchayati Raj Institutions.", icon: <MdCheckCircle size={28} /> },
              { title: "GPDP", desc: "Preparation of Panchayat Development Plan for economic development and social justice.", icon: <MdOutlineAnalytics size={28} /> }
            ].map((scheme, idx) => (
              <div key={idx} className="group bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 relative mt-8 hover:bg-white/15 hover:-translate-y-2 transition-all duration-300 shadow-2xl">
                <div className="absolute -top-8 left-8 w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-emerald-500/30 transform group-hover:rotate-12 transition-transform duration-300">
                  {scheme.icon}
                </div>
                <h3 className="text-xl font-bold mb-4 mt-4 tracking-wide text-white">{scheme.title}</h3>
                <p className="text-sm text-slate-300 mb-8 min-h-[60px] leading-relaxed">
                  {scheme.desc}
                </p>
                <a href="#" className="flex items-center gap-2 text-emerald-400 text-sm font-bold uppercase tracking-wider group-hover:text-emerald-300 transition-colors">
                  Explore <FaArrowRight size={12} className="transform group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section >

      {/* Modern What's New & Photo Gallery */}
      < section className="max-w-[1400px] mx-auto px-4 py-24 grid grid-cols-1 lg:grid-cols-2 gap-12" >
        {/* What's New Card */}
        < div className="bg-white rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100 flex flex-col h-[550px] overflow-hidden" >
          <div className="bg-gradient-to-r from-slate-50 to-white border-b border-slate-100 p-6 flex items-center justify-between">
            <h3 className="text-xl font-black text-slate-900 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-sm">📄</span>
              Latest Updates
            </h3>
            <span className="px-3 py-1 bg-red-50 text-red-600 text-xs font-bold rounded-full border border-red-100">LIVE</span>
          </div>
          <div className="p-6 overflow-y-auto flex-1 space-y-6 custom-scrollbar">
            {[
              "कपिलो ग्राम पंचायत के आंगनबाड़ी केंद्रों, विद्यालयों, और सार्वजनिक स्थलों पर 100 आकर्षक RCC पार्क बेंच की स्थापना का शुभारंभ किया गया है।",
              "आज दिनांक ०९.१०.२०२४ को पश्चिमी सिंहभूम के जगन्नाथपुर प्रखंड में मनरेगा के अंतर्गत तीन दिवसीय प्रशिक्षण का सफल समापन किया गया।",
              "गुमला जिले में राष्ट्रीय पंचायत पुरस्कार 2023-24 के लिए स्टेट लेवल वेरिफिकेशन टीम द्वारा परसा पंचायत (रायडीह) एवं कलिंगा पंचायत में भौतिक सत्यापन किया गया।",
              "सरायकेला जिले के इचागढ़ प्रखंड में 14 पंचायतों के मुखिया, पंचायत सचिव एवं VLE के लिए MGNREGA संबंधित तीन दिवसीय प्रशिक्षण का दूसरा दिन सफलतापूर्वक संपन्न हुआ।"
            ].map((news, idx) => (
              <div key={idx} className="group relative pl-6 pb-6 border-l-2 border-slate-100 last:border-0 last:pb-0">
                <div className="absolute -left-[5px] top-1 w-2 h-2 rounded-full bg-blue-500 shadow-[0_0_8px_rgba(59,130,246,0.6)] group-hover:scale-150 transition-transform"></div>
                <span className="bg-gradient-to-r from-red-500 to-rose-600 text-white text-[10px] px-2 py-0.5 rounded flex items-center w-max font-bold mb-2 shadow-sm uppercase tracking-wider">NEW UPDATE</span>
                <p className="text-sm text-slate-600 leading-relaxed font-medium group-hover:text-slate-900 transition-colors">
                  {news}
                </p>
              </div>
            ))}
          </div>
        </div >

        {/* Photo Gallery Card */}
        < div className="bg-white rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100 flex flex-col h-[550px] overflow-hidden" >
          <div className="bg-gradient-to-r from-slate-50 to-white border-b border-slate-100 p-6 flex items-center justify-between">
            <h3 className="text-xl font-black text-slate-900 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center text-sm">🖼️</span>
              Photo Gallery
            </h3>
            <button className="bg-slate-900 text-white px-5 py-2 text-xs font-bold rounded-full hover:bg-slate-800 transition-colors hover:shadow-lg hover:-translate-y-0.5 transform">
              View All
            </button>
          </div>
          <div className="p-6 grid grid-cols-3 grid-rows-3 gap-3 flex-1 min-h-0">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
              <div key={item} className="bg-slate-100 overflow-hidden rounded-xl group cursor-pointer relative shadow-sm border border-slate-200">
                <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/20 z-10 transition-colors duration-300"></div>
                <img src={userPlaceholder} alt="gallery" className="w-full h-full object-cover opacity-60 group-hover:scale-110 group-hover:opacity-100 transition-all duration-500" />
              </div>
            ))}
          </div>
        </div >
      </section >

      {/* Modern Footer Section */}
      < footer className="w-full bg-slate-900 text-white pt-20 pb-10 border-t border-slate-800 relative overflow-hidden" >
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-emerald-400 to-yellow-500"></div>
        <div className="max-w-[1400px] mx-auto px-4 grid grid-cols-1 md:grid-cols-12 gap-12 relative z-10">

          {/* Column 1: Logos & Socials */}
          <div className="col-span-1 md:col-span-4 flex flex-col gap-6">
            <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/10 backdrop-blur-sm w-max">
              <div className="bg-white p-1.5 rounded-full shadow-lg">
                <img src={indiaEmblem} alt="India Emblem" className="h-12 w-12 object-cover rounded-full" />
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-bold tracking-wide">पंचायती राज विभाग</span>
                <span className="text-xs font-medium text-slate-400">Government of Jharkhand</span>
              </div>
            </div>

            <p className="text-sm text-slate-400 leading-relaxed pr-8">
              Empowering local governance and rural development across Jharkhand through transparent, digital, and effective Panchayati Raj Institutions.
            </p>

            <div className="flex items-center gap-4 mt-2">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-blue-600 text-white flex items-center justify-center transition-all duration-300 hover:shadow-[0_0_15px_rgba(37,99,235,0.5)]"><FaFacebook size={18} /></a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-slate-700 text-white flex items-center justify-center transition-all duration-300 hover:shadow-[0_0_15px_rgba(51,65,85,0.5)]"><FaXTwitter size={16} /></a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-red-600 text-white flex items-center justify-center transition-all duration-300 hover:shadow-[0_0_15px_rgba(220,38,38,0.5)]"><FaYoutube size={18} /></a>
            </div>
          </div>

          {/* Links Columns Container */}
          <div className="col-span-1 md:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {/* Column 2 */}
            <div>
              <h3 className="text-sm font-bold uppercase tracking-widest text-slate-300 mb-6 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-blue-500"></span> Primary Links
              </h3>
              <ul className="space-y-4 text-sm text-slate-400 font-medium">
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Gram Manchitra</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Vibrant Gram Sabha</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Lok Sabha</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Rajya Sabha</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Vidhan Sabha</a></li>
              </ul>
            </div>

            {/* Column 3 */}
            <div>
              <h3 className="text-sm font-bold uppercase tracking-widest text-slate-300 mb-6 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-emerald-500"></span> External Portals
              </h3>
              <ul className="space-y-4 text-sm text-slate-400 font-medium">
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Raj Bhavan Jharkhand</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Mission Antyodaya</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">NIRD-PR</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Digital India</a></li>
              </ul>
            </div>

            {/* Column 4 */}
            <div>
              <h3 className="text-sm font-bold uppercase tracking-widest text-slate-300 mb-6 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-yellow-500"></span> Support
              </h3>
              <ul className="space-y-4 text-sm text-slate-400 font-medium">
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Feedback</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Website Policies</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Contact Us</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Help Center</a></li>
                <li><a href="#" className="hover:text-white hover:translate-x-1 inline-block transition-transform duration-300">Web Manager</a></li>
              </ul>
            </div>
          </div>

        </div>

        {/* Copyright */}
        <div className="max-w-[1400px] mx-auto px-4 mt-16 pt-8 border-t border-slate-800 text-center flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>© 2024 Department of Panchayati Raj, Govt. of Jharkhand. All rights reserved.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </footer >

      {/* Tailwind Custom Utilities injected via style for complex animations */}
      < style dangerouslySetInnerHTML={{
        __html: `
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}} />

    </div >
  );
}
